export const LOCALE_PREFIXES = ["tr", "es", "pt", "ru"];
export const ALL_LANGS = ["en", ...LOCALE_PREFIXES];
export const OG_LOCALE = { en: "en_US", tr: "tr_TR", es: "es_ES", pt: "pt_BR", ru: "ru_RU" };

export function localeFromPath(pathname) {
    const seg = (pathname || "/").split("/")[1];
    return LOCALE_PREFIXES.includes(seg) ? seg : null;
}

export function stripLocale(pathname) {
    const loc = localeFromPath(pathname);
    if (!loc) return pathname || "/";
    const rest = pathname.slice(loc.length + 1);
    return rest || "/";
}

export function localizedPath(lang, pathname) {
    const base = stripLocale(pathname || "/");
    if (!lang || lang === "en") return base;
    return base === "/" ? `/${lang}` : `/${lang}${base}`;
}
